module.exports = __webpack_public_path__ + "static/c4-50936545ec576fcd57c7513ed6086505.jpg";